// extracted by mini-css-extract-plugin
module.exports =  {"bpSmMin":"0","bpMdMin":"750px","bpDtMin":"1024px","bpDtLMin":"1440px","bpDtXLMin":"1920px","copy":"overlayParagraph__copy___bFHBV"};